import { color } from 'echarts';
import { formatWithCommas, roundToWholeNumber, convertToHours } from '../utils/utils';
import { calculateMaxValue,toSentenceCase } from '../utils/utils';
import { data } from 'cypress/types/jquery';
export const statisticsPerVisit = (categories,idx,modalityOptions)=>{
    //statistics of each column
    const modalityCollection={}
    const modalitySummary={}
    const columnConditionCollection = []
    if(categories.soaLabs?.length>0){
      categories.soaLabs.forEach( ele=>{
        columnConditionCollection.push( ele.condition[idx])
      })
    }
    if(categories.soaPhysicalExamination?.length>0){
      categories.soaPhysicalExamination.forEach( ele=>{
        columnConditionCollection.push( ele.condition[idx])
      })

    }
    if(categories.soaProcedures?.length>0){
      categories.soaProcedures.forEach( ele=>{
        columnConditionCollection.push( ele.condition[idx])
      })

    }
    if(categories.soaQuestionaires?.length>0){
      categories.soaQuestionaires.forEach( ele=>{
        columnConditionCollection.push( ele.condition[idx])
      })
    }
    if(categories.soaStudy_procedures?.length>0){
      categories.soaStudy_procedures.forEach( ele=>{
        columnConditionCollection.push( ele.condition[idx])
      })
    }
    columnConditionCollection.filter(element=>element&&element.modality&&element.modality!=="")
    .forEach( element=>{
    if( Object.keys(modalityCollection).indexOf(element.modality.toString())<0 ){
      modalityCollection[element.modality.toString()]=[element]
    }else{
      modalityCollection[element.modality.toString()].push(element)
    }})
    modalityOptions.forEach( option=>{
     if(option.key&&option.key!==""){
      if(Object.keys(modalityCollection).indexOf(option.key.toString())===-1){
        modalitySummary[option.name]=0
      }else{
        modalitySummary[option.name]=modalityCollection[option.key.toString()].length
      }
     }
    })
    return modalitySummary
  }
  export const getModalitySeriesData = (categories,visits, setModalityChartData, modalityOptions, statisticsPerVisit) =>{
    const modalitySeries=[]
    const visitStacks=visits.map( (ele,idx)=>{
      return statisticsPerVisit(categories,idx, modalityOptions)
    })
    if(visitStacks.filter(v=>v!==undefined).length===0) return
    modalityOptions.forEach((element,idx)=>{
      const data = visitStacks.map( v=>{
        return v[element.name]
      })
      modalitySeries.push({
        name: element.name,
        type: 'bar',
        stack: 'total',
        emphasis: {
          focus: 'series'
        },
        data,
        color:element.color
      })
    })
    setModalityChartData(modalitySeries)
  }

export const padArrayToLength = (arr, length)=> {
  if (arr === undefined) return
  if (arr.length >= length) {
    return arr; 
  }
  const newArray = [...arr]; 
  while (newArray.length < length) {
    newArray.push({
      soa_insight_type: "Dimension",
      dimension_name: "",
      patient_burden: 0,
      dct_patient_burden: 0,
    });
  }
  return newArray;
}




export const getChartOptions = (
  PBVisit = { 
  total_dct_pb_per_visit: [], 
  total_dct_pb: 0, 
  sht_total_pb_median: 0, 
  sht_total_pb_median_first_visit: 0, 
  sht_total_pb_median_visits: 0,
  dct_pb_state: ""},
  TimeSpentByVisitData={ 
    tb_by_visit: [], 
    total_tb: 0, 
    sht_total_tb_median: 0, 
    sht_total_tb_median_first_visit: 0, 
    sht_total_tb_median_subseq_visits: 0,
    tb_state: ""
  },
  costPerVisit = { 
    cost_per_state: [], 
    total_cost: 0, 
    sht_total_cost_median: 0, 
    sht_total_cost_median_first_visit: 0, 
    sht_total_cost_median_subseq_visits: 0, 
    cost_state: ""},
  PBbyCategoryInsightsData,
  DCTonPBInsightsData,
  costPerPatientByCategoryData,
  countOfSOAByCategoryData,
  soaActivitiesCount = {
    total_count_per_visit:[],
    total_count: 0,
    sht_total_count_median:0,
    median_count_soa_subsequent_visits:0,
    median_count_soa_first_visit:0,
    count_state:""
  },
  leftValue,
  currentVisitTypes,
  DCTonSBInsightsData,
  SBbyCategoryInsightsData,
  SBVisit = { 
    total_dct_sb_per_visit: [], 
    total_dct_sb: 0, 
    sht_total_sb_median: 0, 
    sht_total_sb_median_first_visit: 0, 
    sht_total_sb_median_visits: 0,
    dct_sb_state: ""},
  ) => {

    const { maxYChartValue: maxPatientBurden, tickValue } = calculateMaxValue(PBVisit.total_dct_pb_per_visit, 'dct_patient_burden', PBVisit.sht_total_pb_median_first_visit, PBVisit.sht_total_pb_median_visits);

    const { maxYChartValue:maxCostperPatient, tickValue: costpatientInterval } = calculateMaxValue(costPerVisit.cost_per_state, 'cost_per_visit', costPerVisit.sht_total_cost_median_first_visit, costPerVisit.sht_total_cost_median_subseq_visits);
    
    const { maxYChartValue:maxSoAActivitiesCount, tickValue: soaActivitiesInterval } = calculateMaxValue(soaActivitiesCount.total_count_per_visit, 'soa_count_per_visit', soaActivitiesCount.median_count_soa_first_visit, soaActivitiesCount.median_count_soa_subsequent_visits);

    const { maxYChartValue: maxTimeBurden, tickValue: timeBurdenInterval } = calculateMaxValue(TimeSpentByVisitData.tb_by_visit, 'time_burden', TimeSpentByVisitData.sht_total_tb_median_first_visit, TimeSpentByVisitData.sht_total_tb_median_subseq_visits);
   
    const { maxYChartValue: maxSiteBurden, tickValue: siteBurdenInterval } = calculateMaxValue(SBVisit.total_dct_sb_per_visit, 'dct_site_burden', SBVisit.sht_total_sb_median_first_visit, SBVisit.sht_total_sb_median_visits);

 const PBbyActivityCategoryOption = {
  grid: {
    top: '8%',
    left: leftValue,
    right: '10%',
    bottom: '11%'
  },
  xAxis: {
    type: 'value',
    name: 'Patient burden',
    nameLocation: 'center',
    nameGap: 30,
    axisLabel: {
      textStyle: {
        align: 'center'
      },
      lineStyle: {
        opacity: 0.5
      }
    }
  },
  yAxis: {
    type: 'category',
    data: PBbyCategoryInsightsData&&PBbyCategoryInsightsData.map(item => item.activity_category),
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.5
      }
    },
    axisLabel: {
      textStyle: {
        wordWrap: 'break-word'
      },
      margin: 12
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      type: 'scatter',
      name: 'Soa',
      symbolSize: 20,
      data: PBbyCategoryInsightsData&&PBbyCategoryInsightsData.map((item, index) => {
        let res  = {}
        res['value'] = [ Math.round(item.dct_patient_burden), index]||[]
        res['label'] = Math.round(item.dct_patient_burden) ===  Math.round(item.historic_patient_burden)?{
          show: false,
          formatter: (d) => ``,
          fontWeight: 1000
        }:{
          show: false,
          formatter: (d) => `${formatWithCommas(d.value[0])}`,
          fontWeight: 1000
        }
        res['emphasis'] = {
          label: {
            show: true,
            formatter: (d) => `${formatWithCommas(d.value[0])}`,
            fontWeight: 1000
          },
        }
        return res
        }
      ),
      itemStyle: {
        color: '#EB8C00', 
      }
    },
    {
      type: 'scatter',
      name: 'Historical median',
      symbolSize: 20,
      data: PBbyCategoryInsightsData&&PBbyCategoryInsightsData.map((item, index) => {
        let res  = {}
        res['value']= [ Math.round(item.historic_patient_burden), index]||[]
          res['symbolOffset'] = Math.round(item.dct_patient_burden) ===  Math.round(item.historic_patient_burden)?[6, 0]:[0, 0];
          res['emphasis'] = {
            label: {
              show: true,
              formatter: (d) => `${formatWithCommas(d.value[0])}`,
              fontWeight: 1000
            },
          }
          return res
        }
      ),
      label: {
        show: false,
        formatter: (d) => `${formatWithCommas(d.value[0])}`,
        fontWeight: 1000, 
      },
      itemStyle: { 
        color: '#FEDACC'
      }
    }
  ]
}

const DCTonPBOption = {
  tooltip: {
    trigger: 'item',
    formatter: '{b}<br />{c}'
    // axisPointer: {
    //   type: 'shadow',
    // }
  },
  legend: {
    show:false,
  },
  grid: {
    top: '2%',
    left: '3%',
    right: '2%',
    bottom: '0%',
    containLabel: true,
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: false,
    }
  },
  xAxis: {
    type: 'category',
    axisLabel: { 
      width: 78, 
      overflow: 'truncate',  
      ellipsis: '...',
      interval: 0,
      rotate: 10,
      margin: 16,
      align: 'center',
      fontSize: 11,
    },
    axisLine: {
      // show: false,
    },
    axisTick: {
      // show: false,
    },
    data: DCTonPBInsightsData&&DCTonPBInsightsData.map(item => item.dimension_name)
  },
  series: [
    {
      name: 'Total patient burden with DCT',
      type: 'bar',
      // stack: 'total',
      color: '#295477',
      label: {
        show: false
      },
      itemStyle: {
        // borderRadius: [10,0,0,10]
      },
      barMaxWidth: 25,
      emphasis: {
        // focus: 'series'
      },
      data: (DCTonPBInsightsData&&DCTonPBInsightsData.map(item => Math.round(item.dct_patient_burden * 100) / 100))||[]
    },
    {
      name: 'Total patient burden without DCT',
      type: 'bar',
      // stack: 'total',
      color: '#FFB600',
      label: {
        show: false
      },
      itemStyle: {
        // borderRadius: [0,10,10,0]
      },
      barMaxWidth: 25,
      emphasis: {
        // focus: 'series'
      },
     data: (DCTonPBInsightsData&&DCTonPBInsightsData.map(item => Math.round(item.patient_burden * 100) / 100))||[]
    },   
  ]
}

const costPatientByCategoryOption = {
  grid: {
    top: '8%',
    left: leftValue,
    right: '10%',
    bottom: '11%'
  },
  xAxis: {
    type: 'value',
    name: 'Cost per patient',
    nameLocation: 'center',
    nameGap: 30,
    axisLabel: {
      textStyle: {
        align: 'center'
      },
      lineStyle: {
        opacity: 0.5
      }
    }
  },
  yAxis: {
    type: 'category',
    data: costPerPatientByCategoryData&&costPerPatientByCategoryData.map(item => item.activity_category),
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.5
      }
    },
    axisLabel: {
      textStyle: {
        wordWrap: 'break-word'
      },
      margin: 12
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      type: 'scatter',
      name: 'SoA',
      symbolSize: 20,
      data: costPerPatientByCategoryData&&costPerPatientByCategoryData.map((item, index) => {
        let res  = {}
        res['value'] = [ Math.round(item.soa_cost), index]||[]
        res['label'] = Math.round(item.soa_cost) ===  Math.round(item.historic_soa_cost)?{
          show: false,
          formatter: (d) => ``,
          fontWeight: 1000
        }:{
          show: false,
          formatter: (d) => `$${formatWithCommas(d.value[0])}`,
          fontWeight: 1000
        }
        res['emphasis'] = {
          label: {
            show: true,
            formatter: (d) => `$${formatWithCommas(d.value[0])}`,
            fontWeight: 1000
          },
        }
        return res
        }
      ),
      itemStyle: {
        color:'#EB8C00', 
      }
    },
    {
      type: 'scatter',
      name: 'Historical median',
      symbolSize: 20,
      data: costPerPatientByCategoryData&&costPerPatientByCategoryData.map((item, index) => {
        let res  = {}
        res['value']= [ Math.round(item.historic_soa_cost), index]||[]
        res['symbolOffset'] = Math.round(item.soa_cost) ===  Math.round(item.historic_soa_cost)?[6, 0]:[0, 0]
        res['emphasis'] = {
          label: {
            show: true,
            formatter: (d) => `$${formatWithCommas(d.value[0])}`,
            fontWeight: 1000
          },
        }
        return res
      }
      ),
      label: {
        show: false,
        formatter: (d) => `$${formatWithCommas(d.value[0])}`,
        fontWeight: 1000,
        opacity: 1
      },
      itemStyle: {  
        opacity: 0.7, // Set high opacity for emphasized data points  
        color: '#FEDACC'
      }
    }
  ]
}

const countSOAbyCategoryOption = {
  grid: {
    top: '8%',
    left: leftValue,
    right: '10%',
    bottom: '11%'
  },
  xAxis: {
    type: 'value',
    name: 'SoA activities',
    nameLocation: 'center',
    nameGap: 30,
    axisLabel: {
      textStyle: {
        align: 'center'
      },
      lineStyle: {
        opacity: 0.5
      }
    }
  },
  yAxis: {
    type: 'category',
    data: countOfSOAByCategoryData&&countOfSOAByCategoryData.map(item => item.activity_category),
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.5
      }
    },
    axisLabel: {
      textStyle: {
        wordWrap: 'break-word'
      },
      margin: 12
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      type: 'scatter',
      name: 'SoA',
      symbolSize: 20,
      data: countOfSOAByCategoryData&&countOfSOAByCategoryData.map((item, index) => {
        let res  = {}
        res['value']= [ Math.round(item.soa_count), index]||[]
        res['label'] = Math.round(item.soa_count) ===  Math.round(item.historic_soa_count)?{
          show: false,
          formatter: (d) => ``,
          fontWeight: 1000
        }:{
          show: false,
          formatter: (d) => `${formatWithCommas(d.value[0])}`,
          fontWeight: 1000
        }
        res['emphasis'] = {
          label: {
            show: true,
            formatter: (d) => `${formatWithCommas(d.value[0])}`,
            fontWeight: 1000
          }
        }
        return res
        }
      ),
      itemStyle: {
        color: '#EB8C00',
      }
    },
    {
      type: 'scatter',
      name: 'Historical median',
      symbolSize: 20,
      data: countOfSOAByCategoryData&&countOfSOAByCategoryData.map((item, index) => {
        let res  = {}
        res['value']= [ Math.round(item.historic_soa_count), index]||[]
          res['symbolOffset'] =  Math.round(item.soa_count) ===  Math.round(item.historic_soa_count)?[6, 0]:[0, 0]
          res['emphasis'] = {
            label: {
              show: true,
              formatter: (d) => `${formatWithCommas(d.value[0])}`,
              fontWeight: 1000
            }
          }
          return res
        }
      ),
      label: {
        show: false,
        formatter: (d) => `${formatWithCommas(d.value[0])}`,
        fontWeight: 1000
      },
      itemStyle: {
        color: '#FBD0B3'
      }
    }
  ]
}

 const visitChartOption = { 
  grid: {
    top: 150,
    left: '10%',
    right: '5%'
  },
  graphic: [
    {
      type: 'line',
      y: 40,
    },
    {
        type: 'text',
        left: '5%',
        top: 30,
        style: {
            text : formatWithCommas(Math.round(PBVisit?.total_dct_pb))??'0',
            fontSize: 36,
            fontWeight: 'bold'
        }
    },
    {
        type: 'text',
        left: '5%',
        top: 70,
        style: {
            text: toSentenceCase(PBVisit?.dct_pb_state || 'LOW'),
            fontWeight: 'bold',
            fontSize: 18,
            fill: PBVisit?.dct_pb_state ==='LOW'?'#00A947':PBVisit?.dct_pb_state ==='MEDIUM'?'#0084A9':PBVisit?.dct_pb_state ==='HIGH'?'#c33232':'#00A947',
        }
    },
    {
        type: 'text',
        right: '5%',
        top: 50,
        style: {
            text: PBVisit ? `Median from similar historical trials - ${PBVisit?.sht_total_pb_median ? formatWithCommas(Math.round(PBVisit?.sht_total_pb_median)): '0'}` : '',
            fontSize: 16,
        }
    }
  ], 
  xAxis: {
      type: 'category',
      name: 'Visit number', 
      data: Array.from(PBVisit?.total_dct_pb_per_visit ?? [], (element) => element.visit_id.toString()) ,
      nameLocation: 'middle',
      nameGap: 30,
      nameRotate: 0,
  },
  yAxis: {
    type: 'value',
    name: 'Patient burden',
    min: 0,
    max: maxPatientBurden,
    interval:tickValue,
    nameLocation: 'middle',
    nameGap: 45,
    axisLabel: {
      formatter: (value) => `${formatWithCommas(value)}` ,
    },
},
  tooltip: {
    show: true,
    trigger: 'item',
    formatter: function (param, index) {      
      return formatWithCommas((param?.data?.value[1] ?? '0'));
    }
  },
  series: [
      {
          type: 'bar',
          data: PBVisit?.total_dct_pb_per_visit?.map((item, index) => {
            return {
              value: [item.visit_index, Math.round(item['dct_patient_burden'])],
              itemStyle: {
                color: currentVisitTypes === 'total_trial'?'#D04A02':(item?.visit_type? (item?.visit_type === currentVisitTypes ? '#D04A02':'#DEDEDE'):'#D04A02')
              },
            }
          }
        ),
          // itemStyle: {
          //   color: chartColor
          // },
          markPoint: {
              symbol: 'diamond',
              symbolSize: PBVisit?.total_dct_pb_per_visit?.length > 20 ? 5 : 12, 
              itemStyle: {
              color: 'black',
              backgroundColor: 'black',
              borderColor: 'black',
            },
              data: PBVisit?.total_dct_pb_per_visit?.map((item, idx) => ({ 
                coord: [item.visit_index, item.visit_id === 1 ? Math.round(PBVisit?.sht_total_pb_median_first_visit) :  Math.round(PBVisit?.sht_total_pb_median_visits)],
                value: item.visit_id === 1 ? `Median patient burden from the first visit of similar trials: ${PBVisit?.sht_total_pb_median_first_visit? formatWithCommas(Math.round(PBVisit?.sht_total_pb_median_first_visit)):'0'}` : `Median patient burden from subsequent visits of historical trials: ${Math.round(PBVisit?.sht_total_pb_median_visits)? formatWithCommas(Math.round(PBVisit?.sht_total_pb_median_visits)):'0'}`,
                label: {
                    show: false,
                    color: '#fff', 
                    shadowColor: 'transparent' ,
                    fontSize: '0px'
                }, 
            })),
              tooltip: {
                show: true,
                trigger: 'item',
                  formatter: function (param, index) { 
                      return param.value;
                  }
              }
          }
      }
  ]
};

const costVisitChartOption = { 
grid: {
  top: 120,
  left: '10%',
  right: '5%'
},
graphic: [
  {
    type: 'line',
    y: 40,
  },
  {
      type: 'text',
      left: '5%',
      top: 30,
      style: {
          text :   `$${roundToWholeNumber(costPerVisit?.total_cost)?? '0'}`,
          fontSize: 36,
          fontWeight: 'bold'
      }
  },
  {
      type: 'text',
      left: '5%',
      top: 70,
      style: {
          text: toSentenceCase(costPerVisit?.cost_state || 'LOW'),
          fontWeight: 'bold',
          fontSize: 18,
          fill: costPerVisit?.cost_state ==='LOW'?'#00A947':costPerVisit?.cost_state ==='MEDIUM'?'#0084A9':costPerVisit?.cost_state ==='HIGH'?'#c33232':'#00A947',
      }
  },
  {
      type: 'text',
      right: '5%',
      top: 50,
      style: {
        text :   costPerVisit?`Median from similar historical trials - $${costPerVisit?.sht_total_cost_median? formatWithCommas(Math.round(costPerVisit?.sht_total_cost_median)): '0'}` : '',
        fontSize: 16,
       
      },
     
  },
], 
xAxis: {
    type: 'category',
    name: 'Visit number', 
    data: Array.from(costPerVisit?.cost_per_state ?? [], (element) => element.visit_id.toString()),
    nameLocation: 'middle',
    nameGap: 30,
    nameRotate: 0,
},
yAxis: {
    type: 'value',
    name: 'Cost per patient',
    min: 0,
    max: maxCostperPatient,
    interval:costpatientInterval,
    nameLocation: 'middle',
    nameGap: 45,
    axisLabel: {
      formatter: (value) => `$${formatWithCommas(value)}` , 
    },
},
tooltip: {
  show: true,
  trigger: 'item',
  formatter: function (param, index) {
    return formatWithCommas((param?.data?.value[1] ?? '0'));
  }
},
series: [
    {
        type: 'bar',
        data: costPerVisit?.cost_per_state?.map((item, index) =>  {
          return {
            value: [item.visit_index, item['cost_per_visit']],
            itemStyle: {
              color: currentVisitTypes === 'total_trial'?'#D04A02':(item?.visit_type? (item?.visit_type === currentVisitTypes ? '#D04A02':'#DEDEDE'):'#D04A02')
            },
          }
        }), 
        // itemStyle: {
        //   color: '#D04A02'
        // },
        markPoint: {
            symbol: 'diamond',
            symbolSize: costPerVisit?.cost_per_state?.length > 20 ? 5 : 12, 
            itemStyle: {
            color: 'black',
            backgroundColor: 'black',
            borderColor: 'black',
          },
          data: costPerVisit?.cost_per_state?.map((item, idx) => ({ 
            coord: [item.visit_index, item.visit_id === 1 ? Math.round(costPerVisit?.sht_total_cost_median_first_visit ) :  Math.round(costPerVisit?.sht_total_cost_median_subseq_visits)],
            value: item.visit_id === 1 ? `Median cost per patient from the first visit of similar trials: $${costPerVisit?.sht_total_cost_median_first_visit? formatWithCommas(Math.round(costPerVisit?.sht_total_cost_median_first_visit)):'0'}` : `Median cost per patient from subsequent visits of historical trials: $${Math.round(costPerVisit?.sht_total_cost_median_subseq_visits)? formatWithCommas(Math.round(costPerVisit?.sht_total_cost_median_subseq_visits)):'0'}`,
              label: {
                  show: false,
                  color: '#fff', 
                  shadowColor: 'transparent' ,
                  fontSize: '0px'
              }, 
          })),
            tooltip: {
              show: true,
              trigger: 'item',
                formatter: function (param, index) { 
                    return param.value;
                }
            }
        }
    }
]
};

const soaActivitiesChartOption = { 
  grid: {
    top: 120,
    left: '10%',
    right: '5%'
  },
  graphic: [
    {
      type: 'line',
      y: 40,
    },
    {
        type: 'text',
        left: '5%',
        top: 30,
        style: {
            text :   Math.round(soaActivitiesCount?.total_count)??'0' ,
            fontSize: 36,
            fontWeight: 'bold'
        }
    },
    {
        type: 'text',
        left: '5%',
        top: 70,
        style: {
            text: toSentenceCase(soaActivitiesCount?.count_state || 'LOW'),
            fontWeight: 'bold',
            fontSize: 18,
            fill: soaActivitiesCount?.count_state ==='LOW'?'#00A947':soaActivitiesCount?.count_state ==='MEDIUM'?'#0084A9':soaActivitiesCount?.count_state ==='HIGH'?'#c33232':'#00A947',
        }
    },
    {
        type: 'text',
        right: '5%',
        top: 50,
        style: {
          text : soaActivitiesCount ? `Median from similar historical trials - ${soaActivitiesCount?.sht_total_count_median ?Math.round(soaActivitiesCount?.sht_total_count_median): '0'}` : '',
          fontSize: 16,
        },
    },
  ], 
  xAxis: {
      type: 'category',
      name: 'Visit number', 
      data: Array.from(soaActivitiesCount?.total_count_per_visit ?? [], (element) => element?.visit_id?.toString()) ,
      nameLocation: 'middle',
      nameGap: 30,
      nameRotate: 0,
  },
  yAxis: {
      type: 'value',
      name: 'SoA activities',
      min: 0,
      max: maxSoAActivitiesCount,
     interval:soaActivitiesInterval,
      nameLocation: 'middle',
      nameGap: 45,
      axisLabel: {
        formatter: (value) => `${formatWithCommas(value)}`, 
      },
  },
  tooltip: {
    show: true,
    trigger: 'item',
    formatter: function (param, index) {      
      return formatWithCommas((param?.data?.value[1] ?? '0'));
    }
  },
  series: [
      {
          type: 'bar',
          data: soaActivitiesCount?.total_count_per_visit?.map((item, index) =>  {
            return {
              value: [item.visit_index, item['soa_count_per_visit']],
              itemStyle: {
                color: currentVisitTypes === 'total_trial'?'#D04A02':(item?.visit_type? (item?.visit_type === currentVisitTypes ? '#D04A02':'#DEDEDE'):'#D04A02')
              },
            }
          }), 
          // itemStyle: {
          //   color: '#D04A02'
          // },
          markPoint: {
              symbol: 'diamond',
              symbolSize: soaActivitiesCount?.total_count_per_visit?.length > 20 ? 5 : 12, 
              itemStyle: {
              color: 'black',
              backgroundColor: 'black',
              borderColor: 'black',
            },
              data: soaActivitiesCount?.total_count_per_visit?.map((item, idx) => ({ 
                coord: [item.visit_index, item.visit_id === 1 ? Math.round(soaActivitiesCount?.median_count_soa_first_visit) : Math.round(soaActivitiesCount?.median_count_soa_subsequent_visits)],
                value: item.visit_id === 1 ? `Median of activities in the first visit of similar trials: ${soaActivitiesCount?.median_count_soa_first_visit? formatWithCommas(Math.round(soaActivitiesCount?.median_count_soa_first_visit)):'0'}` : `Median of activities from subsequent visits of historical trials: ${Math.round(soaActivitiesCount?.median_count_soa_subsequent_visits)? formatWithCommas(Math.round(soaActivitiesCount?.median_count_soa_subsequent_visits)):'0'}`,

                label: {
                    show: false,
                    color: '#fff', 
                    shadowColor: 'transparent' ,
                    fontSize: '0px'
                }, 
            })),
              tooltip: {
                show: true,
                trigger: 'item',
                  formatter: function (param, index) { 
                      return param.value;
                  }
              }
          }
      }
  ]
};

const DCTonSBOption = {
  tooltip: {
    trigger: 'item',
    formatter: '{b}<br />{c}'
  },
  legend: {
    show: false,
  },
  grid: {
    top: '2%',
    left: '3%',
    right: '2%',
    bottom: '0%',
    containLabel: true,
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: false,
    },
    // max: function (value) {      
    //   return Math.round(value.max + value.max/10);
    // }
  },
  xAxis: {
    type: 'category',
    axisLabel: { 
      width: 78, 
      overflow: 'truncate',  
      ellipsis: '...',
      interval: 0,
      rotate: 10,
      margin: 16,
      align: 'center',
      fontSize: 11,
    },
    data: DCTonSBInsightsData?.map(item => item.sb_dimension_name)
  },
  series: [
    {
      name: 'Total site burden with DCT',
      type: 'bar',
      // stack: 'total',
      color: '#295477',
      label: {
        show: false
      },
      itemStyle: {
        // borderRadius: [10,0,0,10]
      },
      barMaxWidth: 25,
      emphasis: {
        // focus: 'series'
      },
      data: DCTonSBInsightsData?.map(item => Math.round(item.oh_dct_site_burden * 100) / 100)??[]
    },
    {
      name: 'Total site burden without DCT',
      type: 'bar',
      // stack: 'total',
      color: '#FFB600',
      label: {
        show: false
      },
      itemStyle: {
        // borderRadius: [0,10,10,0]
      },
      barMaxWidth: 25,
      emphasis: {
        // focus: 'series'
      },
     data: (DCTonSBInsightsData&&DCTonSBInsightsData.map(item => Math.round(item.oh_site_burden * 100) / 100))||[]
    },   
  ]
}

const TimeByCategoryOption = {
  grid: {
    top: '8%',
    left: leftValue,
    right: '10%',
    bottom: '11%'
  },
  xAxis: {
    type: 'value',
    name: 'Time per patient',
    nameLocation: 'center',
    nameGap: 30,
    axisLabel: {
      formatter: (value) => `${value} h`,
      textStyle: {
        align: 'center'
      },
      lineStyle: {
        opacity: 0.5
      }
    }
  },
  yAxis: {
    type: 'category',
    // name: 'Activity Category', 
    data: SBbyCategoryInsightsData&&SBbyCategoryInsightsData.map(item => item.activity_category),
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.5
      }
    },
    axisLabel: {
      textStyle: {
        wordWrap: 'break-word'
      },
      margin: 12
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      type: 'scatter',
      name: 'Soa',
      symbolSize: 20,
      data: SBbyCategoryInsightsData&&SBbyCategoryInsightsData.map((item, index) => {
        let res  = {}
        res['value'] = [ convertToHours(item.soa_time_burden), index]||[]
        res['label'] = convertToHours(item.soa_time_burden) ===  convertToHours(item.historic_time_burden)?{
          show: false,
          formatter: (d) => ``,
          fontWeight: 1000
        }:{
          show: false,
          formatter: (d) => `${formatWithCommas(d.value[0])}`,
          fontWeight: 1000
        }
        res['emphasis'] = {
          label: {
            show: true,
            formatter: (d) => `${formatWithCommas(d.value[0])}`,
            fontWeight: 1000
          },
        }
        return res
        }
      ),
      itemStyle: {
        color: '#EB8C00', 
      }
    },
    {
      type: 'scatter',
      name: 'Historical median',
      symbolSize: 20,
      data: SBbyCategoryInsightsData&&SBbyCategoryInsightsData.map((item, index) => {
        let res  = {}
        res['value']= [ convertToHours(item.historic_time_burden), index]||[]
          res['symbolOffset'] = convertToHours(item.soa_time_burden) ===  convertToHours(item.historic_time_burden)?[6, 0]:[0, 0];
          res['emphasis'] = {
            label: {
              show: true,
              formatter: (d) => `${formatWithCommas(d.value[0])}`,
              fontWeight: 1000
            },
          }
          return res
        }
      ),
      label: {
        show: false,
        formatter: (d) => `${formatWithCommas(d.value[0])}`,
        fontWeight: 1000, 
      },
      itemStyle: { 
        color: '#FEDACC'
      }
    }
  ]
}

const sitevisitChartOption = {
  grid: {
    top: 150,
    left: '10%',
    right: '5%'
  },
  graphic: [
    {
      type: 'line',
      y: 40,
    },
    {
        type: 'text',
        left: '5%',
        top: 30,
        style: {
            text : formatWithCommas(Math.round(SBVisit?.total_dct_sb))??'0',
            fontSize: 36,
            fontWeight: 'bold'
        }
    },
    {
        type: 'text',
        left: '5%',
        top: 70,
        style: {
            text: toSentenceCase(SBVisit?.dct_sb_state || 'LOW'),
            fontWeight: 'bold',
            fontSize: 18,
            fill: SBVisit?.dct_sb_state ==='LOW'?'#00A947':SBVisit?.dct_sb_state ==='MEDIUM'?'#0084A9':SBVisit?.dct_sb_state ==='HIGH'?'#c33232':'#00A947',
        }
    },
    {
        type: 'text',
        right: '5%',
        top: 50,
        style: {
            text: SBVisit ? `Median from similar historical trials - ${SBVisit?.sht_total_sb_median ? formatWithCommas(Math.round(SBVisit?.sht_total_sb_median)): '0'}` : '',
            fontSize: 16,
        }
    }
  ], 
  xAxis: {
      type: 'category',
      name: 'Visit number', 
      data: Array.from(SBVisit?.total_dct_sb_per_visit ?? [], (element) => element.visit_id.toString()) ,
      nameLocation: 'middle',
      nameGap: 30,
      nameRotate: 0,
  },
  yAxis: {
    type: 'value',
    name: 'Site burden',
    min: 0,
    max: maxSiteBurden,
    interval:siteBurdenInterval,
    nameLocation: 'middle',
    nameGap: 45,
    axisLabel: {
      formatter: (value) => `${formatWithCommas(value)}` ,
    },
},
  tooltip: {
    show: true,
    trigger: 'item',
    formatter: function (param, index) {      
      return formatWithCommas((param?.data?.value[1] ?? '0'));
    }
  },
  series: [
      {
          type: 'bar',
          data: SBVisit?.total_dct_sb_per_visit?.map((item, index) => {
            return {
              value: [item.visit_index, Math.round(item['dct_site_burden'])],
              itemStyle: {
                color: currentVisitTypes === 'total_trial'?'#D04A02':(item?.visit_type? (item?.visit_type === currentVisitTypes ? '#D04A02':'#DEDEDE'):'#D04A02')
              },
            }
          }
        ),
          // itemStyle: {
          //   color: chartColor
          // },
          markPoint: {
              symbol: 'diamond',
              symbolSize: SBVisit?.total_dct_sb_per_visit?.length > 20 ? 5 : 12, 
              itemStyle: {
              color: 'black',
              backgroundColor: 'black',
              borderColor: 'black',
            },
              data: SBVisit?.total_dct_sb_per_visit?.map((item, idx) => ({ 
                coord: [item.visit_index, item.visit_id === 1 ? Math.round(SBVisit?.sht_total_sb_median_first_visit) :  Math.round(SBVisit?.sht_total_sb_median_visits)],
                value: item.visit_id === 1 ? `Median site burden from the first visit of similar trials: ${SBVisit?.sht_total_sb_median_first_visit? formatWithCommas(Math.round(SBVisit?.sht_total_sb_median_first_visit)):'0'}` : `Median site burden from subsequent visits of similar trials: ${Math.round(SBVisit?.sht_total_sb_median_visits)? formatWithCommas(Math.round(SBVisit?.sht_total_sb_median_visits)):'0'}`,
                label: {
                    show: false,
                    color: '#fff', 
                    shadowColor: 'transparent' ,
                    fontSize: '0px'
                }, 
            })),
              tooltip: {
                show: true,
                trigger: 'item',
                  formatter: function (param, index) { 
                      return param.value;
                  }
              }
          }
      }
  ]
 }

const exceedsThreshold = TimeSpentByVisitData?.tb_by_visit?.some(item => item['time_burden'] > 4);
const final_tb = TimeSpentByVisitData?.total_tb > 60 ? (convertToHours(TimeSpentByVisitData?.total_tb)) + ' h': (TimeSpentByVisitData?.total_tb || 0) + ' mins';
const TimeSpentByVisitOption = { 
  grid: {
    top: 150,
    left: '12%',
    right: '5%'
  },
  graphic: [
    {
      type: 'line',
      y: 40,
    },
    {
        type: 'text',
        left: '5%',
        top: 30,
        style: {
            text : `${final_tb}`,
            fontSize: 30,
            fontWeight: 'bold'
        }
    },
    {
      type: 'text',
      left: '5%',
      top: 70,
      style: {
          text: 'Median Scenario Visit Time',
          fontSize: 16,
          fill: '#CA4A04'
      }
  },
  ], 
  xAxis: {
      type: 'category',
      name: 'Visit number', 
      data: [
        ...Array.from(TimeSpentByVisitData?.tb_by_visit ?? [], (element) => element?.visit_id?.toString()),
        ''
      ],
      nameLocation: 'middle',
      nameGap: 30,
      nameRotate: 0,
      axisLabel: {
        show: true,
        formatter: (value, index) => index === TimeSpentByVisitData?.tb_by_visit?.length ? '' : value
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
        length: 5,
        lineStyle: {
          color: '#000000'
        },
        interval: (index, value) => index !== TimeSpentByVisitData?.tb_by_visit?.length
      }
  },
  yAxis: {
    type: 'value',
    name: 'Time burden',
    min: 0,
    max: maxTimeBurden,
    interval:timeBurdenInterval,
    nameLocation: 'middle',
    nameGap: 45,
    axisLabel: {
      formatter: (value) => `${formatWithCommas(value)} h` ,
    },
    splitLine: {
      show: true,
    }
  },

  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    },
    formatter: function (param, index) {      
      const totalValue = param.reduce((acc, cur) => acc + cur.value[1], 0);
      return `${formatWithCommas(totalValue)}`;
    }
  },
  
  series: [
      {
          type: 'bar',
          stack: 'total',
          data: TimeSpentByVisitData?.tb_by_visit?.map((item, index) => {
            const originalColor = currentVisitTypes === 'total_trial' ? '#D04A02' : (item?.visit_type ? (item?.visit_type === currentVisitTypes ? '#D04A02' : '#DEDEDE') : '#D04A02');
            const yValue = item['time_burden'];
            const belowThreshold = Math.min(yValue, 4);
            return {
              value: [item.visit_index, belowThreshold],
                itemStyle: {
                    color: originalColor
                }
            };
          }),
        ...(exceedsThreshold ? {
          markLine: {
            symbol: ['none', 'arrow'],
            data: [
                {
                    yAxis: 4,
                      lineStyle: {
                        color: 'red',
                        type: 'solid',
                        width: 3
                    },
                    label: {
                       show: false ,
                       offset: [500, 50],
                    },
                
                    tooltip: {
                      show: true,
                      trigger: 'item',
                      formatter: () => 'Based on patient feedback, participants prefer visits under 4 hours', 
                      padding: 8,
                      textStyle: {
                        color: '#000000', 
                        fontSize: 12,
                      }
                    }
                },
                
            ]
          }
        }:{}),
          markPoint: {
              symbol: 'diamond',
              symbolSize: TimeSpentByVisitData?.tb_by_visit?.length > 20 ? 5 : 12, 
              itemStyle: {
              color: 'black',
              backgroundColor: 'black',
              borderColor: 'black',
            },
              data: TimeSpentByVisitData?.tb_by_visit?.map((item, idx) => ({ 
                coord: [item.visit_index, item.visit_id === 1 ? TimeSpentByVisitData?.sht_total_tb_median_first_visit : TimeSpentByVisitData?.sht_total_tb_median_subseq_visits],
                value: item.visit_id === 1 ? `
                Median time spent from the first visit of similar trials: ${TimeSpentByVisitData?.sht_total_tb_median_first_visit? formatWithCommas(TimeSpentByVisitData?.sht_total_tb_median_first_visit):'0'}` : `Median time spent from subsequent visits of similar trials: ${TimeSpentByVisitData?.sht_total_tb_median_subseq_visits? formatWithCommas(TimeSpentByVisitData?.sht_total_tb_median_subseq_visits):'0'}`,
                label: {
                    show: false,
                    color: '#fff', 
                    shadowColor: 'transparent' ,
                    fontSize: '0px'
                }, 
            })),
              tooltip: {
                show: true,
                trigger: 'item',
                  formatter: function (param, index) { 
                      return param.value;
                  }
              }
          }
      },
      {
        type: 'bar',
        stack: 'total', 
        barGap: '-100%', 
        data: TimeSpentByVisitData?.tb_by_visit?.map((item) => {
            const yValue = item['time_burden'];
            const aboveThreshold = yValue > 4 ? yValue - 4 : 0; // Part of the value above the threshold
            return {
                value: [item.visit_index, aboveThreshold],
                itemStyle: {
                    color: aboveThreshold > 0 ? '#8B0000' : 'transparent' // Only color the bar if it has a value above the threshold
                }
            };
        })
      },
  ]
};

  return {
    PBbyActivityCategoryOption,
    TimeSpentByVisitOption,
    DCTonPBOption,
    costPatientByCategoryOption,
    countSOAbyCategoryOption,
    visitChartOption,
    costVisitChartOption,
    soaActivitiesChartOption,
    DCTonSBOption,
    TimeByCategoryOption,
    sitevisitChartOption
  }
}

export const compareString = (original, sub_str) => {
  let index = original.toLocaleLowerCase().indexOf(sub_str)
  return original.substring(index, sub_str.length)
}

export const compareMiddle = (original, sub_str) => {
  let index = original.toLocaleLowerCase().indexOf(sub_str);
  let secondIndex = original.toLocaleLowerCase().length === sub_str.toLocaleLowerCase().length ? original.toLocaleLowerCase().length : index+sub_str.length;
  return original.substring(index, secondIndex)
}

export const filterOptions = (options, attr,val) => {
  // sort search data by length and if lengths are equal, sort alphabetically 
  options.sort((a, b) => {
    if (a[attr].length < b[attr].length) return -1;
    if (a[attr].length > b[attr].length) return 1;
    if (a[attr].toLowerCase() < b[attr].toLowerCase()) return -1;
    if (a[attr].toLowerCase() > b[attr].toLowerCase()) return 1;
    return 0;
  })
  const exactMatches = options.filter(
      (i) =>
          typeof i[attr] === 'string' &&
          i[attr].toLowerCase() === val
  );
  const otherMatches = options.filter(
      (i) =>
          typeof i[attr] === 'string' &&
          i[attr].toLowerCase().indexOf(val) > -1 &&
          i[attr].toLowerCase() !== val
  );
  return [...exactMatches, ...otherMatches];
};

/**  
 * Filters an array of objects to retain only the first occurrence of objects  
 * with unique values for a specified property.  
 *  
 * @param {Array} arr - The array of objects to filter.  
 * @param {string} uniId - The property name used to determine uniqueness.  
 * @returns {Array} A new array with objects having unique values for the specified property.  
 */
export function uniqueArray(arr, uniId){
  // Create a Map to track the unique property values encountered
  const res = new Map();
  // Filter the array, keeping only the first occurrence of each unique property value  
  return arr.filter((item) =>
    // Check if the property value has not been encountered  
    !res.has(item[uniId]) &&
    // If not, add the property value to the Map and keep the item  
    res.set(item[uniId], 1)
  );
}

/**
 * return true if 2 arraies are same
 * @param a 
 * @param b 
 * @returns 
 */
export const compareArrays = (a: any[], b: any[]) => {
  return a.length === b.length && a.every(element => b.find(item => (item || "") === (element || "")));
}

export const deepEqual = (obj1, obj2) => {  
  if (obj1 === obj2) return true; // Check for strict equality  
  
  if (typeof obj1 !== 'object' || obj1 === null ||   
      typeof obj2 !== 'object' || obj2 === null) return false; // Check if both are objects  
  
  const keys1 = Object.keys(obj1);  
  const keys2 = Object.keys(obj2);  
  
  if (keys1.length !== keys2.length) return false; // Check if they have the same number of keys  
  
  for (let key of keys1) {  
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false; // Recursive check for values  
  }  
  
  return true;  
}  